import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function respuestaComboReducer(state= initialState.respuestaCombo, action){
	switch(action.type){
		case types.GET_RESPUESTAS_COMBO_SUCCESS:		            
			return action.datos;		
	
		default:
			return state;
	}
}